import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { AutocompleteParams } from "apis/data-contracts";
import useDebouncedState from "features/common/hooks/useDebouncedState";

const useUsersAutocompleteQuery = (options: Partial<AutocompleteParams>) => {
  const option = useDebouncedState(options, 500);

  return useQuery({
    queryKey: api.user.autocompleteKey(option as AutocompleteParams),
    queryFn: () => api.user.autocomplete(option as AutocompleteParams),
    enabled:
      option?.keyword !== undefined &&
      option?.type !== undefined &&
      option?.keyword.trim() !== "",
    placeholderData: (pre) => pre,
  });
};

export default useUsersAutocompleteQuery;
